import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { IconLibrary } from '@product-framework/index';
import DialogCloseButton from '../DialogCloseButton';
import { ServiceProviderProvider } from '../../../providers/ServiceProviderProvider';
import AssignToSPQuestion from './components/AssignToSPQuestion';
import AssignJobFlow from './components/AssignJobFlow';
import SPOrSPDispatchInActiveCheck from './components/SPOrSPDispatchInActiveCheck';

function AssignJobDialog({
  open,
  onClose,
  serviceJob,
  selectedServiceProvider,
  isAssign = false,
  isReAssign = false,
}) {
  const { sp: serviceProvider, location } = selectedServiceProvider;
  const { dispatchEvent } = serviceProvider;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: '800px',
            width: '100%',
          },
        },
      }}
      fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.AssignServiceJob />
        {isAssign && (
          <FormattedMessage id="ASSIGN_JOB" defaultMessage="Assign Job" />
        )}
        {isReAssign && (
          <FormattedMessage id="REASSIGN_JOB" defaultMessage="Reassign Job" />
        )}
        &nbsp;&ndash;
        <Typography color="primary" variant="body">
          {serviceJob?.serviceJobNumber}
        </Typography>
        <DialogCloseButton onClose={onClose} />
      </DialogTitle>
      <ServiceProviderProvider
        init
        serviceProviderId={serviceProvider?.id}
        loadProfileWarnings={false}
        loadDispatch
        loadSPInfo
        loadUser={false}
        loadLocation={false}>
        <SPOrSPDispatchInActiveCheck onClose={onClose}>
          <AssignToSPQuestion
            isAssign={isAssign}
            isReAssign={isReAssign}
            onClose={onClose}>
            <AssignJobFlow
              onClose={onClose}
              serviceJob={serviceJob}
              isAssign={isAssign}
              isReAssign={isReAssign}
              location={location}
              dispatchEvent={dispatchEvent}
            />
          </AssignToSPQuestion>
        </SPOrSPDispatchInActiveCheck>
      </ServiceProviderProvider>
    </Dialog>
  );
}

export default AssignJobDialog;
